module.exports = __webpack_public_path__ + "static/media/20ECE3.19b7a377.jpg";